module.exports = __webpack_public_path__ + "img/detail_slip.fe2a24b3.png";